import { Injectable } from '@angular/core';
import { HandlerService } from '../../handlers/handlers.service';
import { MethodsService } from '../method.service';
import { environment as params } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

// declare module "*.json" {
//   const value: any;
//   export default value;
// }

// import * as priceTravel from '../../../../assets/json/price-travel.json';

@Injectable({
  providedIn: 'root'
})
export class WidgetService extends MethodsService {
  public UrlBase: string;
  constructor(_HandlerService: HandlerService, http: HttpClient, private http2: HttpClient) {
    super(_HandlerService, http);
    this.setApi((<any>params).api.wp);
  }
  getAirports() {
    return this.get('apimj/fuv/airports');
  }
  getAirPortsGrouped() {
    return this.get('apimj/fuv/airportsGroup');
  }
  getAirlines() {
    return this.get('apimj/fuv/airlines');
  }
  getCountries() {
    return this.get('apimj/fuv/countries');
  }
  getCities() {
    return this.get('apimj/fuv/cities');
  }
  getNewMetodAirPortsGrouped () {
    return this.http2.get('https://web-back.mundojoven.com/flight_back/flights/airports')
      .map((data: any) => this._HandlerService.success(data))
      .catch(this._HandlerService.error);
  }
  getDestinationforWidget(){
    // let myHeaders = new HttpHeaders({ 
    //   'Access-Control-Allow-Origin': '*',
    //   'Content-Type': 'application/json',
    //   'Cache-Control': 'private'
    //  }); 
    
    return this.http2.get('https://www.priceres.com.mx/mundojoven/GetDestinationforWidget')
      .map((data: any) => this._HandlerService.success(data))
      .catch(this._HandlerService.error);
  }
  //Eliminar si no se usan o funciona
  flightsHotel(data){
    return this.http2.post('https://paqnacionales.mundojoven.com/QuoteFromCustomWidget', data)
      .map((data: any) => this._HandlerService.success(data))
      .catch(this._HandlerService.error);
  }
  flightsHotelSearch(){
    return this.http2.get('https://paqnacionales.mundojoven.com/paquetes/destinos?isQuote=True')
      .map((data: any) => this._HandlerService.success(data))
      .catch(this._HandlerService.error);
  }
  getDestinations(query='mexico'): Observable<any>{
    return this.http2.get('https://lookup.hotels.com/1/suggest/v1.8/json?locale=es_MX&boostConfig=config-boost-9&excludeLpa=false&query=' + query)
      .map((data: any) => this._HandlerService.success(data))
      .catch(this._HandlerService.error);
  }
}
